import { render, staticRenderFns } from "./AprobarPlanIns.vue?vue&type=template&id=4acbf7f3&scoped=true"
import script from "./AprobarPlanIns.vue?vue&type=script&lang=js"
export * from "./AprobarPlanIns.vue?vue&type=script&lang=js"
import style0 from "./AprobarPlanIns.vue?vue&type=style&index=0&id=4acbf7f3&prod&scoped=true&lang=css"
import style1 from "./AprobarPlanIns.vue?vue&type=style&index=1&id=4acbf7f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acbf7f3",
  null
  
)

export default component.exports